import React, { useState, useEffect } from 'react';

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 100);
    const t2 = setTimeout(() => setPhase(2), 1200);
    const t3 = setTimeout(() => setPhase(3), 2200);
    const t4 = setTimeout(() => onComplete(), 3000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onComplete]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 40%, #2563eb 100%)',
        opacity: phase >= 3 ? 0 : 1,
        transition: 'opacity 0.8s ease-out',
        pointerEvents: phase >= 3 ? 'none' : 'auto'
      }}
    >
      {/* Animated circles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 rounded-full opacity-10"
          style={{
            background: 'radial-gradient(circle, #3b82f6, transparent)',
            top: '-10%', left: '-10%',
            transform: phase >= 1 ? 'scale(1.5)' : 'scale(0)',
            transition: 'transform 1.5s ease-out'
          }}
        />
        <div className="absolute w-80 h-80 rounded-full opacity-10"
          style={{
            background: 'radial-gradient(circle, #60a5fa, transparent)',
            bottom: '-5%', right: '-5%',
            transform: phase >= 1 ? 'scale(1.8)' : 'scale(0)',
            transition: 'transform 1.8s ease-out 0.2s'
          }}
        />
      </div>

      <div className="text-center relative z-10">
        {/* Logo icon */}
        <div
          style={{
            transform: phase >= 1 ? 'scale(1) rotate(0deg)' : 'scale(0) rotate(-180deg)',
            opacity: phase >= 1 ? 1 : 0,
            transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)'
          }}
          className="w-24 h-24 mx-auto mb-6 bg-white/10 backdrop-blur-xl rounded-3xl flex items-center justify-center border border-white/20 shadow-2xl"
        >
          <svg viewBox="0 0 24 24" className="w-12 h-12 text-white" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" />
          </svg>
        </div>

        {/* Title */}
        <h1
          className="text-6xl font-black text-white tracking-tight"
          style={{
            transform: phase >= 1 ? 'translateY(0)' : 'translateY(40px)',
            opacity: phase >= 1 ? 1 : 0,
            transition: 'all 0.8s ease-out 0.3s'
          }}
        >
          SHALEM
        </h1>

        {/* Tagline */}
        <p
          className="text-blue-200 text-lg mt-3 font-light"
          style={{
            transform: phase >= 2 ? 'translateY(0)' : 'translateY(20px)',
            opacity: phase >= 2 ? 1 : 0,
            transition: 'all 0.6s ease-out'
          }}
        >
          Government Services, Simplified
        </p>

        {/* Loading bar */}
        <div className="mt-8 mx-auto w-48 h-1 bg-white/10 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-blue-400 to-white rounded-full"
            style={{
              width: phase >= 2 ? '100%' : '0%',
              transition: 'width 1.5s ease-out'
            }}
          />
        </div>
      </div>
    </div>
  );
}
